import React from "react";

import firebaseUtil from "firebaseUtil";
import { useNavigate } from "react-router-dom";
import useNotification from "notification";

import DefaultCrudForm from "components/form/DefaultCrudForm";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import TextInput from "components/form/input/TextInput";

import User from "entity/User";
import SelectInput from "components/form/input/SelectInput";
import getGruposPermissao from "entity/GrupoPermissao";


function UserCreateInter(props) {

    const {values} = props;
    console.log("values ", values);
    
    return (
        <FormContent sx={{ m: 1 }}>
            <FormRow>
                <SelectInput
                    sx={{ flex: 0.2 }}
                    name="status"
                    label="Status"
                    
                    options={["ATIVO", "INATIVO"]}
                    disabled
                />
                <TextInput name="nome" label="Nome" required />
                <TextInput type="email" name="email" label="E-mail" required />
               
                
            </FormRow>
            <FormRow>
            <TextInput type="password" name="senha" label="Senha" required />
                <TextInput type="password" name="confirmarSenha" label="Confirmar Senha" required />
            </FormRow>
            <FormRow>
            <TextInput type="tel" name="telefone" label="Telefone" required />
            <SelectInput
                  
                    name="grupoPermissao"
                    label="Grupo Permissão"
                    options={getGruposPermissao().map(item => item.nome)}
                    toStringOptions={getGruposPermissao().map(g => {
                        return g.nome
                    })}
                    required
                />
            </FormRow>
           
        </FormContent>
    );
}

export default function UserCreate() {
    const navigate = useNavigate();
    const { showWarning, showError } = useNotification();

    const validValues = (values) => {
        if (values.senha !== values.confirmarSenha) {
            showWarning("As senhas estão diferentes");
            return false;
        }

        if (values.email) {
            let isEmailValid = String(values.email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
            if (!isEmailValid) {
                showWarning("Email inválido");
                return false;
            }
        }

        return true;
    };

    const saveValues = (values) => {
        // console.log('saveValues', values)

        firebaseUtil
            .registerNoLogin(values.email, values.senha)
            .then((user) => {

                let usuario = new User(); 

                const permission = getGruposPermissao()
                const findPermission = permission.find(item => item.nome === values.grupoPermissao)

                usuario.update({
                    uid: user.user.uid,
                    nome: values.nome,
                    email: values.email,
                    telefone: values.telefone,
                    status: values.status,
                    grupoPermissao: findPermission
                });

                usuario.save().then(() => {
                    navigate("/_usuario?uid=" + user.user.uid);
                });
            })
            .catch((error) => {
                // console.log("error", error)

                switch (error.code) {
                    case "auth/invalid-email":
                        showError("Endereço de e-mail Inválido");
                        break;
                    case "auth/email-already-in-use":
                        showError("Endereço de e-mail já em uso");
                        break;
                    case "auth/weak-password":
                        showError("Senha muito fraca");
                        break;
                    // case 'auth/user-disabled':
                    //     showError('O usuário pode ter sido desativado')
                    //     break;
                    // case 'auth/user-not-found':
                    //     showError('Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído')
                    //     break;
                    // case 'auth/wrong-password':
                    //     showError('Senha inválida ou o usuário não tem uma senha')
                    //     break;
                    default:
                        break;
                }
            });
    };

    return (
        <DefaultCrudForm saveValues={saveValues} formActions={{salvarForm:true}} validValues={validValues} initialValues={{status:'ATIVO'}} backRoute="consulta-usuario">
            {(formProps) => {
                return <UserCreateInter {...formProps} />;
            }}
        </DefaultCrudForm>
    );
}
